<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <EditorGroupTabs
        :editor-group="editorGroup"
        v-model="currentTab"
        @delete="deleteEditor"
        @edit="editEditor"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="editor_group">
          <EditorGroupDetails :editor-group="editorGroup"/>
        </v-tab-item>
        <v-tab-item value="editor">
          <EditorGroupEditorTableDetails :editor-group="editorGroup"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';
  import { editorsGroupService } from '../../utils/services/editorsGroup.service';

  import EditorGroupTabs from '../../components/app/EditorsGroups/EditorGroupTabs.vue';
  import EditorGroupDetails from '../../components/app/EditorsGroups/EditorGroupDetails.vue';
  import EditorGroupEditorTableDetails from '../../components/app/EditorsGroups/EditorGroupEditorTableDetails.vue';
  import EditorGroupModal from '../../components/modals/EditorsGroups/EditorGroupModal.vue';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'EditorGroupShow',
    components: {
        Loader,
        EditorGroupTabs,
        EditorGroupDetails,
        EditorGroupEditorTableDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        editorGroup: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchEditor(id) {
        return editorsGroupService.get(id)
        .then(response => {
          this.editorGroup = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteEditor() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return editorsGroupService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(`/${this.routeName.EDITOR_GROUP}`);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editEditor() {
          this.showModal({
              component: EditorGroupModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('EDITOR'),
                onSave: (
                  form,
                  error,
                ) => editorsGroupService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchEditor(this.id);
      this.loading = false;
    },
  };
</script>
